import { useFormContext, Controller } from 'react-hook-form';
import { Button, ButtonGroup, Label } from 'reactstrap';
import { PaymentOptions as PaymentTypes } from '~/enums/PaymentOptions.enum';

function PaymentOptions() {
    const { control, setValue } = useFormContext();

    const paymentOptionsArray = [
        { label: 'Check', value: PaymentTypes.CHECK },
        { label: 'Direct Deposit (ACH)', value: PaymentTypes.ACH },
    ];

    const getButtonStyles = (isSelected: boolean) => ({
        backgroundColor: isSelected ? '#01aeb4' : '',
        borderColor: isSelected ? '#01aeb4' : '',
    });

    return (
        <>
            <Label style={{ fontSize: '0.8rem' }}>
                Preferred Payment Method
                <span className='required'>*</span>
            </Label>
            <Controller
                name='new_vendor.payment_type'
                control={control}
                defaultValue='CHECK'
                render={({ field }) => (
                    <ButtonGroup style={{ gap: '10px' }}>
                        {paymentOptionsArray.map((option) => (
                            <Button
                                key={option.value}
                                color='outline-dark'
                                size='sm'
                                style={{
                                    ...getButtonStyles(
                                        field.value === option.value
                                    ),
                                    fontSize: '0.8rem',
                                    padding: '5px 15px',
                                    marginRight: '10px',
                                    textTransform: 'none',
                                }}
                                onClick={() => {
                                    setValue(
                                        'new_vendor.payment_type',
                                        option.value
                                    );
                                    setValue('payment_type', option.value);
                                    
                                    // Clear ACH info when switching to CHECK
                                    if (option.value === PaymentTypes.CHECK) {
                                        setValue('ach_info', undefined);
                                    }
                                }}
                            >
                                {option.label}
                            </Button>
                        ))}
                    </ButtonGroup>
                )}
            />
        </>
    );
}

export default PaymentOptions;
